<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: home</title>
  <path d="M1,11 L12,3 L23,11 M5,11 v11 h14 v-11 M18,7 v-4" />
</Icon>

<style>
  path {
    fill: none;
    stroke: currentColor;
  }
</style>
